import React from "react";
import { Route, Redirect } from "react-router-dom";
import { routes } from "./routes";

const PrivateRoute = (props) => {
  const subDomain = localStorage.getItem("subDomain");
  const isLoggedIn = localStorage.getItem("token");
  return (isLoggedIn && subDomain) ? (
    <Route {...props} />
  ) : (
    <Redirect
      to={{
        pathname: routes.login.path,
        state: { from: props.location },
      }}
    />
  );
};

export default PrivateRoute;
